export default "/_next/static/images/95c780b6e17299cd5cfac5c9fde45779.jpg";